import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import { links } from "@shared/constants";
import { Trans } from "@shared/utils/internationalization";
import { PropsWithChildren } from "react";

function Disclaimer(props: PropsWithChildren): React.JSX.Element {
  const { children } = props;
  return (
    <Text as="span" color="gray.600">
      {children}
    </Text>
  );
}

function FaqLink(props: PropsWithChildren): React.JSX.Element {
  const { children } = props;
  return (
    <a
      href={links.helpCenterDocs.DONATION_FAQS}
      target="_blank"
      rel="noreferrer"
    >
      <Text as="span" color="gray.600" textDecoration="underline">
        {children}
      </Text>
    </a>
  );
}

export default function DonationsFootnotes() {
  return (
    <Box mt="md" mb={{ base: "4", sm: "none" }}>
      <Text fontSize="sm" as="p" color="gray.600">
        <Trans
          i18nKey="donationFootnote"
          components={{
            faq: <FaqLink />,
            disclaimer: <Disclaimer />,
          }}
          ns="constants"
        />
      </Text>
    </Box>
  );
}
